import { ExpectedInbound, ExpectedOutbound, ExpectedOutboundState } from '../api/models';

export const ExpectedOutboundIncompleteStates = ['Created', 'InProgress'];

export function isExpectedOutboundFinished(expectedOutbound: ExpectedOutbound) {
	return expectedOutbound.state == ExpectedOutboundState.Completed || expectedOutbound.state == ExpectedOutboundState.Canceled;
}
